import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity/src/models';
import { FMIssueList, FMGeneralRequestModel, PaginationModel, PagedResult, FMAllRequestsModel, AnnouncementRequestsModel, RequestVenue, EventRequestModel, RequestGeneral, AppFile } from '@app/core';


export enum DashboardAction {


  DashboardRequests = '[DashboardAction] Load All FM Requests',
  DashboardRequestsFail = '[DashboardAction] Load All FM Requests Fail',
  DashboardRequestsSuccess = '[DashboardAction] Load All FM Requests Success',

  LoadUpcomingMeetings = '[DashboardAction] Load Upcoming Meetings',
  LoadUpcomingMeetingsFail = '[DashboardAction] Load Upcoming Meetings Fail',
  LoadUpcomingMeetingsSuccess = '[DashboardAction] Load Upcoming Meetings Success',

  LoadUpcomingEvents = '[DashboardAction] Load Upcoming Events',
  LoadUpcomingEventsFail = '[DashboardAction] Load Upcoming Events Fail',
  LoadUpcomingEventsSuccess = '[DashboardAction] Load Upcoming Events Success',

  LoadPushedAnnouncements = '[DashboardAction] Load Pushed Announcements',
  LoadPushedAnnouncementsSuccess = '[DashboardAction] Load Pushed Announcements Success',
  LoadPushedAnnouncementsFail = '[DashboardAction] Load Pushed Announcements Fail',

  AddFeedback = "[DashboardAction] Add Feedback annoncement",
  AddFeedbackSuccess = "[DashboardAction] Add Feedback annoncement Success",
  AddFeedbackFail = "[DashboardAction] Add Feedback annoncement Fail",

  LoadAllRequests = '[DashboardAction] Load All Requests',
  LoadAllRequestsFail = '[DashboardAction] Load All Requests Fail',
  LoadAllRequestsSuccess = '[DashboardAction] Load All Requests Success',

  LoadResourceCenter = '[DashboardAction] Load Resource Center',
  LoadResourceCenterFail = '[DashboardAction] Load Resource Center Fail',
  LoadResourceCenterSuccess = '[DashboardAction] Load Resource Center Success',
}


export class DashboardRequests implements Action {
  readonly type = DashboardAction.DashboardRequests;
  constructor(public payload: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }) { }
}

export class DashboardRequestsFail implements Action {
  readonly type = DashboardAction.DashboardRequestsFail;
  constructor(public payload: any) { }
}

export class DashboardRequestsSuccess implements Action {
  readonly type = DashboardAction.DashboardRequestsSuccess;
  constructor(public payload: PagedResult<FMAllRequestsModel>) { }

}

export class LoadUpcomingMeetings implements Action {
  readonly type = DashboardAction.LoadUpcomingMeetings;
  constructor(public payload: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }) { }
}

export class LoadUpcomingMeetingsFail implements Action {
  readonly type = DashboardAction.LoadUpcomingMeetingsFail;
  constructor(public payload: any) { }
}

export class LoadUpcomingMeetingsSuccess implements Action {
  readonly type = DashboardAction.LoadUpcomingMeetingsSuccess;
  constructor(public payload: PagedResult<RequestVenue>) { }
}

export class LoadUpcomingEvents implements Action {
  readonly type = DashboardAction.LoadUpcomingEvents;
  constructor(public payload: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }) { }
}

export class LoadUpcomingEventsFail implements Action {
  readonly type = DashboardAction.LoadUpcomingEventsFail;
  constructor(public payload: any) { }
}

export class LoadUpcomingEventsSuccess implements Action {
  readonly type = DashboardAction.LoadUpcomingEventsSuccess;
  constructor(public payload: PagedResult<EventRequestModel>) { }
}

export class LoadPushedAnnouncements implements Action {
  readonly type = DashboardAction.LoadPushedAnnouncements;

}

export class LoadPushedAnnouncementsSuccess implements Action {
  readonly type = DashboardAction.LoadPushedAnnouncementsSuccess;
  constructor(public payload: AnnouncementRequestsModel[]) { }
}

export class LoadPushedAnnouncementsFail implements Action {
  readonly type = DashboardAction.LoadPushedAnnouncementsFail;
  constructor(public payload: any) { }
}

export class AddFeedback implements Action {
  readonly type = DashboardAction.AddFeedback;
  constructor(public payload: { id: number, comments: string }) { }
}
export class AddFeedbackFail implements Action {
  readonly type = DashboardAction.AddFeedbackFail;
  constructor(public payload: any) { }
}
export class AddFeedbackSuccess implements Action {
  readonly type = DashboardAction.AddFeedbackSuccess;
  constructor(public payload: any) { }
}

export class LoadAllRequests implements Action {
  readonly type = DashboardAction.LoadAllRequests;
}

export class LoadAllRequestsFail implements Action {
  readonly type = DashboardAction.LoadAllRequestsFail;
  constructor(public payload: any) { }
}

export class LoadAllRequestsSuccess implements Action {
  readonly type = DashboardAction.LoadAllRequestsSuccess;
  constructor(public payload: RequestGeneral[]) { }
}


export class LoadResourceCenter implements Action {
  readonly type = DashboardAction.LoadResourceCenter;
}

export class LoadResourceCenterFail implements Action {
  readonly type = DashboardAction.LoadResourceCenterFail;
  constructor(public payload: any) { }
}

export class LoadResourceCenterSuccess implements Action {
  readonly type = DashboardAction.LoadResourceCenterSuccess;
  constructor(public payload: AppFile[]) { }
}
export type DashboardActionType =
  | DashboardRequests
  | DashboardRequestsFail
  | DashboardRequestsSuccess
  | LoadPushedAnnouncements
  | LoadPushedAnnouncementsSuccess
  | LoadPushedAnnouncementsFail
  | AddFeedback
  | AddFeedbackFail
  | AddFeedbackSuccess
  | LoadUpcomingMeetings
  | LoadUpcomingMeetingsFail
  | LoadUpcomingMeetingsSuccess
  | LoadUpcomingEvents
  | LoadUpcomingEventsFail
  | LoadUpcomingEventsSuccess
  | LoadAllRequests
  | LoadAllRequestsFail
  | LoadAllRequestsSuccess

  | LoadResourceCenter
  | LoadResourceCenterFail
  | LoadResourceCenterSuccess
  ;







// WEBPACK FOOTER //
// ./src/app/core/store/actions/dashboard.actions.ts